import React from "react";
import { Link } from "react-router-dom";
import sidebarlogo from "../../../assets/images/sidebarlogo.svg";
import "./SideBarcomponent.css";

const BlankSidebar: React.FC = () => {
  return (
    <div className="common_sidebar">
      <div className="sidebar_logo">
        <Link to="/">
          <img src={sidebarlogo} alt="logo" />
        </Link>
      </div>
    </div>
  );
};

export default BlankSidebar;
